import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M4 18a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 17q0-.424.288-.712A.97.97 0 0 1 4 16h16q.424 0 .712.288.288.287.288.712c0 .425-.096.52-.288.712A.97.97 0 0 1 20 18zm0-5a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 12a.97.97 0 0 1 .288-.713A.97.97 0 0 1 4 11h16a.97.97 0 0 1 .712.287Q21 11.575 21 12c0 .425-.096.52-.288.713A.97.97 0 0 1 20 13zm0-5a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 7a.97.97 0 0 1 .288-.713A.97.97 0 0 1 4 6h16a.97.97 0 0 1 .712.287Q21 6.575 21 7c0 .425-.096.52-.288.713A.97.97 0 0 1 20 8z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }